import Vue from 'vue';
import VuePopover from 'vue-js-popover';
Vue.use(VuePopover);
